import { UserCheck, Compass, Phone, LifeBuoy } from "lucide-react";
import { Reveal, ChapterTag } from "@/components/Reveal";

const PILLARS = [
  {
    icon: UserCheck,
    title: "Personally Managed",
    copy: "Your journey receives personal attention rather than being treated like a standard package.",
  },
  {
    icon: Compass,
    title: "Tailored Around You",
    copy: "Your itinerary is designed around your preferences, schedule and budget.",
  },
  {
    icon: Phone,
    title: "One Point of Contact",
    copy: "Instead of coordinating with multiple travel providers yourself, you have one point of contact for your journey.",
  },
  {
    icon: LifeBuoy,
    title: "Support Throughout",
    copy: "We're available to assist when you need support during your journey.",
  },
];

export const WhyNivaan = () => (
  <section data-testid="why-nivaan-section" className="bg-slateDark px-5 py-20 sm:px-8 sm:py-28 lg:px-16 lg:py-36">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <ChapterTag index="03" label="Why Nivaan" />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-10 font-serif text-4xl font-light leading-tight tracking-tight text-zinc-50 sm:text-5xl">
          Why <span className="italic text-gold-gradient">Nivaan?</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={0.1 + i * 0.1}>
            <div
              data-testid={`why-card-${i}`}
              className="group h-full rounded-sm border border-white/10 bg-white/[0.03] p-8 backdrop-blur-md transition-all duration-500 hover:-translate-y-2 hover:border-gold/50 hover:shadow-2xl"
            >
              <p.icon size={26} strokeWidth={1.25} className="text-gold" />
              <h3 className="mt-6 font-serif text-xl font-normal text-zinc-100 sm:text-2xl">{p.title}</h3>
              <p className="mt-4 text-sm font-light leading-relaxed text-zinc-400">{p.copy}</p>
              <div className="mt-6 h-px w-8 bg-gold/40 transition-all duration-500 group-hover:w-16 group-hover:bg-gold" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
